define('SageDotCom/Components/Collections/ImageListing',["jquery"],
    function ($) {
        
        function ImageListing(scope) {
            const screenMdWidth = 1080;
            var currentWindowWidth = $(window).width();
            var $imageListingBox = $(".image-listing-box", scope);
            var $imageBox = $(".image-box", scope);
            var $imageListingHighlight = $(".image-listing-highlight", scope);

            $(".image-listing-highlight-container", scope).prepend($imageListingHighlight); //move highlights to the top
            $(".image-box", scope).appendTo($imageListingBox); //move image-box elements to one element- image-listing-highlight

            addHasHighlightClass($imageBox, scope);
            
            var $imageBoxHasHighlight = $(".image-box.has-highlight", scope);
            $(".image-box.has-highlight", scope).attr("tabindex", "0"); //add focus to image box

            addBoxClassToImageListingBox($imageBox, $imageListingBox);

            $imageBoxHasHighlight.on("click keydown",
                function (event) {
                    if (event.keyCode === 13 || event.type === "click") {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        removeActiveElements($imageListingHighlight, $imageBox);

                        var dataId = $(this).attr("data-id");
                        //add active class
                        $(this).addClass("active"); 
                        $(".image-listing-highlight[data-id=" + dataId + "]").addClass("active");

                        if ($(window).width() < screenMdWidth) { //screen less than 960px
                            addModalElements(dataId);
                            addCloseModalEvent($imageListingHighlight, $imageBox);
                        }
                    }
                });

            resizeWindow($imageListingHighlight, $imageBox, $imageBoxHasHighlight, $imageListingBox, currentWindowWidth, screenMdWidth, scope);
            
            $(document).on("click",
                function(event) {
                    if (event.target.className === "image-listing-highlight active highlight-modal") {
                        removeActiveElements($imageListingHighlight, $imageBox);
                    }
                });

        }
        
        //checking data-id for highlight & image box, add new class
        function addHasHighlightClass(imageBox, scope) {
            imageBox.each(function () {
                var dataId = $(this).attr("data-id");
                if ($(".image-listing-highlight[data-id=" + dataId + "]", scope).children(".score-highlight").length > 0) {
                    $(this).addClass("has-highlight");
                }
            });
        }

        function addBoxClassToImageListingBox($imageBox, $imageListingBox) {
            const length = $imageBox.length;
            if (length > 0 && length <= 12) {
                $imageListingBox.addClass("box-" + length);
            }
        }

        function adjustHeight(imageListingBox, $imageListingHighlight, screenMdWidth) {
            var $activeHighlight = $(".image-listing-highlight.active .score-highlight");
            var $activeListingHighlight = $(".image-listing-highlight.active");
            $imageListingHighlight.height("auto");
            imageListingBox.height("auto");

            if ($(window).width() >= screenMdWidth) {
                var targetHeight = imageListingBox.outerHeight();
                var highlightHeight = 0;

                //hide active one while calculating heights
                $activeListingHighlight.removeClass('active');

                $imageListingHighlight.each(function(i, el) {
                    $(el).addClass("calculating-height");

                    var currentHeight = $(el).outerHeight();
                    if (currentHeight > highlightHeight) {
                        highlightHeight = currentHeight;
                    }

                    $(el).removeClass("calculating-height");
                });

                $activeListingHighlight.addClass('active');

                if (highlightHeight > targetHeight) {
                    $imageListingHighlight.outerHeight(highlightHeight);
                    imageListingBox.outerHeight(highlightHeight);
                } else {
                    $imageListingHighlight.outerHeight(targetHeight);
                }
            }
        }

        function removeActiveElements($imageListingHighlight, $imageBox) {
            $imageListingHighlight.removeClass("active highlight-modal");
            $imageBox.removeClass("active");
            $(".image-listing-highlight .score-highlight").removeClass("image-listing-highlight-modal")
                .removeAttr("tabindex", "0");
            $(".close-modal-box").remove();
            $("body").removeClass("image-listing-modal");
        }

        function makeFirstHighlightActive(imageBoxHasHighlight) {
            imageBoxHasHighlight[0].classList.add("active");
            var firstImageListingBoxDataId = imageBoxHasHighlight[0].getAttribute("data-id");
            var firstActiveHighlight =
                $(".image-listing-highlight[data-id=" + firstImageListingBoxDataId + "]");
            firstActiveHighlight.addClass("active");
        }

        function addModalElements(dataId) {
            const closeModalHTML = '<div class="close-modal-box" tabindex="0"><div class="close-modal"></div></div>';

            $("body").addClass("image-listing-modal");
            $(".image-listing-highlight[data-id=" + dataId + "]").addClass("highlight-modal");
            $(".image-listing-highlight[data-id=" + dataId + "] .score-highlight").addClass("image-listing-highlight-modal")
                .attr("tabindex", "0")
                .focus()
                .append(closeModalHTML);
        }

        function addCloseModalEvent($imageListingHighlight, $imageBox) {
            $(".close-modal-box, .score-highlight.image-listing-highlight-modal .score-button").on(
                "click keydown", function (event) {
                    if (event.keyCode === 13 || event.type === "click") {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        removeActiveElements($imageListingHighlight, $imageBox);
                    }
                });
        }

        function resizeWindow($imageListingHighlight, $imageBox, $imageBoxHasHighlight, $imageListingBox, currentWindowWidth, screenMdWidth, scope) {
            var resizeTimer = undefined;
            var resizeFinishedTimer = undefined;

            $(window).resize(function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                        console.log("Image listing resize function");
                        //Timeout required otherwise was calculating heights before component had resized itself
                        if (resizeFinishedTimer) {
                            clearTimeout(resizeFinishedTimer);
                        }

                        var newWidth = $(window).width();
                        if ($(window).width() < screenMdWidth) {
                            if (currentWindowWidth > screenMdWidth) {
                                $imageListingHighlight.removeClass("active");
                                $imageBox.removeClass("active");
                                currentWindowWidth = newWidth;
                            }
                        } else {
                            if ((currentWindowWidth < screenMdWidth - 1) || (!$imageListingHighlight.hasClass("active"))) {
                                removeActiveElements($imageListingHighlight, $imageBox);
                                makeFirstHighlightActive($imageBoxHasHighlight);
                            }
                            currentWindowWidth = newWidth;
                        }
                        resizeFinishedTimer = setTimeout(function () {
                                $(scope).trigger("resizeEnd");
                            },
                            300);
                    },
                    100);
            });

            $(scope).on("resizeEnd", function () { adjustHeight($imageListingBox, $imageListingHighlight, screenMdWidth) });
        }

        ImageListing.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ImageListing(args.scope);
        };

        return ImageListing;
    });
